import React from 'react';
import Modal from 'Nori/Modal';
import styles from 'Nori/Modal/ModalSmall.module.scss';

const ModalSmall = ({ className = '', ...props }) => (
  <Modal className={`${styles.small} ${className}`} {...props} />
);

export default ModalSmall;
